module.exports = __webpack_public_path__ + "img/info.784f324d.svg";